import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ltcpRoutes from "../constants/ltcpRoutes";
import { useContext, useEffect, useState } from "react";
import { LTCPContext } from "../LTCPContext";
import RibbonWidget from "./RibbonWidget";
import { useMsal } from "@azure/msal-react";

function LTCPLayout() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { instance, accounts } = useMsal();
  const { demandFile, ribbonMessage, setRibbonMessage } =
    useContext(LTCPContext);
  const [userMenu, setUserMenu] = useState(null);
  const [userInfo, setUserInfo] = useState({ name: "", email: "" });

  let hideDemandInfo = false;

  let hideShortcut = false;

  if (pathname === "/ltcp/dashboard/reports") {
    hideDemandInfo = true;
  } else if (pathname === "/ltcp/dashboard/uploads") {
    hideDemandInfo = true;
  } else if (pathname === "/ltcp/dashboard/roles") {
    hideDemandInfo = true;
  }

  if (pathname === "/ltcp/dashboard/simulation") {
    hideShortcut = true;
  } else if (pathname === "/ltcp/dashboard/alerts") {
    hideShortcut = true;
  } else if (pathname.startsWith("/ltcp/dashboard/recommendation")) {
    hideShortcut = true;
  } else if (pathname === "/ltcp/dashboard/uploads") {
    hideShortcut = true;
  } else if (pathname === "/ltcp/dashboard/reports") {
    hideShortcut = true;
  } else if (pathname === "/ltcp/dashboard/roles") {
    hideShortcut = true;
  }

  const handleLogout = () => {
    setUserMenu(null);
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      setUserInfo({
        name: account.name || account.username || "User",
        email: account.username || account.email || "",
      });
    }
  }, [accounts]);

  return (
    <Box
      width="100vw"
      height="100vh"
      display="flex"
      flexDirection="column"
      position="relative"
      bgcolor={theme.palette.primary.light}
    >
      <AppBar elevation={0} position="static">
        <Toolbar
          variant="dense"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          <Stack direction="row" gap={3}>
            <img
              src="/unilever_logo.svg"
              onClick={() => navigate(ltcpRoutes.LANDING)}
            />
            <Typography
              fontWeight="bold"
              fontSize="21px"
              paddingLeft={3}
              sx={{ borderLeft: "1px solid #ffffff7f" }}
            >
              Capacity Planning
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography fontSize={14}>{userInfo.name}</Typography>
            <IconButton
              sx={{ color: "white" }}
              onClick={() => navigate(ltcpRoutes.LANDING)}
            >
              <HomeOutlinedIcon />
            </IconButton>
            <IconButton
              onClick={(e) => setUserMenu(e.currentTarget)}
              sx={{ color: "white" }}
            >
              <PersonOutlineOutlinedIcon />
            </IconButton>
            <Menu
              open={Boolean(userMenu)}
              anchorEl={userMenu}
              onClose={() => setUserMenu(null)}
            >
              <MenuItem onClick={handleLogout}>
                <LogoutIcon sx={{ fontSize: 14, mr: 2 }} />
                <Typography fontSize={11}>Logout</Typography>
              </MenuItem>
            </Menu>
          </Stack>
          {!hideDemandInfo && (
            <Box
              sx={{
                background: "#2E2E2E",
                color: "#fff",
                position: "absolute",
                height: 20,
                bottom: -20,
                right: 0,
                pl: 5,
                pr: 2,
                clipPath: "polygon(0 0, 100% 0%, 100% 100%, 20% 100%)",
              }}
            >
              <Typography fontSize={12}>Based on {demandFile}</Typography>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Box
        display="flex"
        alignItems="stretch"
        flexDirection="column"
        flexGrow={1}
        sx={{ overflowY: "auto" }}
      >
        <Outlet />
      </Box>
      {!hideShortcut && (
        <>
          <Box
            sx={{
              height: 24,
              width: 110,
              position: "absolute",
              top: "40vh",
              right: -50,
              transform: "rotate(270deg)",
              background: "linear-gradient(90deg, #1F36C7 0%, #1F6BC7 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              px: 1,
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              cursor: "pointer",
            }}
            onClick={() => navigate(ltcpRoutes.ALERTS)}
          >
            <WarningAmberIcon fontSize="small" sx={{ color: "#ff3333" }} />
            <Typography color="white" fontSize={12}>
              ALERTS
            </Typography>
          </Box>
          <Box
            sx={{
              height: 24,
              width: 110,
              position: "absolute",
              top: "60vh",
              right: -50,
              transform: "rotate(270deg)",
              background: "linear-gradient(90deg, #1F36C7 0%, #1F6BC7 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              px: 1,
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              cursor: "pointer",
            }}
            onClick={() => navigate(ltcpRoutes.SIMULATION)}
          >
            <GraphicEqIcon fontSize="small" sx={{ color: "#fff" }} />
            <Typography color="white" fontSize={12}>
              SIMULATION
            </Typography>
          </Box>
        </>
      )}
      <RibbonWidget
        open={Boolean(ribbonMessage)}
        message={ribbonMessage}
        onClose={() => setRibbonMessage(null)}
      />
    </Box>
  );
}

export default LTCPLayout;
